import { aboutInfo } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
            平台介绍
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            {aboutInfo.title}
          </h2>
        </div>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center max-w-2xl mx-auto mb-10">
          {aboutInfo.content}
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {aboutInfo.stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 text-center"
            >
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">{stat.value}</div>
              <div className="text-xs text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}